import { datadogRum } from '@datadog/browser-rum';
import { getDefaultStore } from 'jotai';
import { redirect } from 'react-router-dom';

import {
  cookieJar,
  fetchApplyEligibility,
  toApplyEligibility,
  trackApplyEvent,
  uiRoutes,
} from '@consumer-frontend/nc-api';
import { AccountT, ApplyEligibilityT } from '@consumer-frontend/nc-utils';

import { accountAtom, applyEligibilityAtom } from '../../store';
import { hasPassword, isApplyEligible } from '../checks';

const store = getDefaultStore();

export type ApplyEligibilityEventT = {
  account_validators: {
    active_fraud_lock: boolean;
    application_in_lp?: boolean;
    discharged_loan?: boolean;
    login_lock_active?: boolean;
    open_loan?: boolean;
    reapplication_lock_active?: boolean;
  };
  account_id?: string;
  secured?: boolean;
};

export const serializeEligibilityEventData = (
  account?: Partial<AccountT>,
  eligibility?: Partial<ApplyEligibilityT>,
): ApplyEligibilityEventT => {
  return {
    account_id: account?.accountId,
    account_validators: {
      active_fraud_lock: !!(account?.loginLockActive || account?.reapplicationLockActive),
      application_in_lp: eligibility?.applicationInLp,
      discharged_loan: eligibility?.dischargedLoan,
      login_lock_active: account?.loginLockActive,
      open_loan: eligibility?.openLoan,
      reapplication_lock_active: account?.reapplicationLockActive,
    },
    secured: account?.passwordExists,
  };
};

export const applyEligibilityGuard = async () => {
  if (!cookieJar.getAccessToken()) { return; }

  if (hasPassword() && !store.get(applyEligibilityAtom)) {
    try {
      const eligibilityResponse = await fetchApplyEligibility();

      store.set(applyEligibilityAtom, toApplyEligibility(eligibilityResponse));
    } catch (error) {
      datadogRum.addError(error, { context: 'applyEligibilityGuard' });
    }
  }

  if (!isApplyEligible()) {
    const account = store.get(accountAtom);
    const eligibility = store.get(applyEligibilityAtom);
    const eventData = serializeEligibilityEventData(account, eligibility);

    trackApplyEvent('authorizedUserNotApplyEligible', eventData);

    throw redirect(uiRoutes.legacyAH.accountSummary);
  }
};
